@if (showIcon) {
  <mat-icon [style.color]="iconColor">
    drag_handle
  </mat-icon>
}
